import SwiperCore, { Navigation, Pagination, Scrollbar, A11y, SwiperOptions, Autoplay } from 'swiper';

// install Swiper modules
SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, Autoplay]);

export class SwiperConfig {

    public static banners: SwiperOptions = {
        slidesPerView: 1,
        spaceBetween: 0,
        navigation: true,
        autoplay: true,
        loop: true,
        pagination: { clickable: true },
        scrollbar: { draggable: true },
    };

    public static categories: SwiperOptions = {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 10,
        breakpoints: {
            320: {
                slidesPerView: 2,
                spaceBetween: 10
            },
            576: {
                slidesPerView: 3,
                spaceBetween: 20
            },
            768: {
                slidesPerView: 4,
                spaceBetween: 20
            },
            992: {
                slidesPerView: 5,
                spaceBetween: 20
            }
        }
    };

    public static events: SwiperOptions = {
        loop: true,
        slidesPerView: 1,
        navigation: true,
        scrollbar: { draggable: true },
        breakpoints: {
            576: {
                slidesPerView: 2
            },
            768: {
                slidesPerView: 3
            },
            1400: {
                slidesPerView: 4
            }
        }
    };

    public static cities: SwiperOptions = {
        loop: true,
        slidesPerView: 2,
        navigation: true,
        scrollbar: { draggable: true },
        breakpoints: {
            576: {
                slidesPerView: 3
            },
            768: {
                slidesPerView: 4
            },
            992: {
                slidesPerView: 5
            }
        }
    };

    public static states: SwiperOptions = {
        loop: true,
        slidesPerView: 2,
        navigation: true,
        scrollbar: { draggable: true },
        breakpoints: {
            576: {
                slidesPerView: 3
            },
            768: {
                slidesPerView: 3
            },
            992: {
                slidesPerView: 3
            }
        }
    };

    public static sectors: SwiperOptions = {
        slidesPerView: 1,
        spaceBetween: 15,
        centerInsufficientSlides: true,
        navigation: true,
        scrollbar: { draggable: true },
        breakpoints: {
          360: {
            slidesPerView: 2,
            spaceBetween: 15
          },
          576: {
            slidesPerView: 3,
            spaceBetween: 15
          },
          1200: {
            slidesPerView: 4,
            spaceBetween: 15
          }
        }
    };

    public static ticketHolders: SwiperOptions = {
        slidesPerView: 1,
        spaceBetween: 0,
        simulateTouch: false,
        pagination: { clickable: false },
        scrollbar: { draggable: true },
    };

}
